<template>
  <ul class="ctas">
    <li class="ctas__item">
      <a
        href="https://od.lnk.to/TTTWY"
        rel="noopener noreferrer"
        target="_blank"
        class="ctas__link ctas__link--1"
        >Get the album</a
      >
    </li>
    <li class="ctas__item">
      <button @click="openEpisodes" class="ctas__link ctas__link--2">
        The Asheville Sessions
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  methods: {
    openEpisodes() {
      this.$emit("open-episodes");
    },
  },
};
</script>
